<div class="animated fadeInDown DocumentContainer" *ngIf="showInvoiceVisualizer">

   <div class="InvoiceVisualizerTitle">
    <button class="InvoiceModelChangeButton" mat-raised-button (click)="OpenInvoiceModelSettings();">
      <i class="material-icons" *ngIf="this.CurrentInvoice.ModelSettings.ShowInvoiceSettings != true;">keyboard_arrow_left</i>
      <i class="material-icons" *ngIf="this.CurrentInvoice.ModelSettings.ShowInvoiceSettings == true;">keyboard_arrow_right</i>
      <i class="material-icons" style="font-size: 18px;">settings</i>
    </button>
    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="EfacturaButton" mat-raised-button (click)="GetEFacturaXML(this.CurrentInvoice);">
      <i class="material-icons">download</i>
      <span>{{'DownloadEFactura' | translate}}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="EfacturaButton" mat-raised-button color="accent" (click)="this.ShowEFacturaQuestion = true;" *ngIf="this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == -1 || this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == 0;">
      <i class="material-icons">play_arrow</i>
      <span>{{'APIEFactura' | translate}}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="EfacturaButton" mat-raised-button color="primary" (click)="GetEFacturaState(this.CurrentInvoice);" *ngIf="this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == 1;">
      <i class="material-icons">sync</i>
      <span>{{'UpdateEFacturaStatus' | translate}}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="EfacturaButton" mat-raised-button (click)="GetEFacturaFiles(this.CurrentInvoice);" *ngIf="this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == 2;">
      <i class="material-icons">downloading</i>
      <span>{{'DownloadEFacturaPDF' | translate}}</span>
    </button>
   </div> 

   <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
    <button mat-raised-button color="primary" class="VizualizeCommandButton" style="outline: none;" (click)="ExportInvoice(this.CurrentInvoice);">
      <i class="material-icons">file_copy</i>
      <span>{{ 'Receptions.Document.Export' | translate }}</span>
    </button>

    <button mat-raised-button class="VizualizeCommandButton" style="outline: none;" (click)="PrintInvoice(this.CurrentInvoice);">
      <i class="material-icons">print</i>
      <span>{{ 'Receptions.Document.Print' | translate }}</span>
    </button>

    <button mat-raised-button class="VizualizeCommandButton" style="outline: none;" (click)="this.parent.InitializeEmailSendContainer(this.CurrentInvoice.Client, this.CurrentInvoice.GeneralDocType, this.CurrentInvoice.ID);">
      <i class="material-icons">attach_email</i>
      <span>{{ 'Email' | translate }}</span>
    </button>

    <button mat-raised-button class="VizualizeCommandButton" style="outline: none;" *ngIf="this.CurrentInvoice.Details?.ShippingDetails?.TrackingLabel?.length > 0;" (click)="TrackInvoice(CurrentInvoice);">
      <i class="material-icons">near_me</i>
      <span>{{ 'Track' | translate }}</span>
    </button>

    <button mat-raised-button color="primary" class="BackCommandButton" style="outline: none;float: right; background: #32aa3a;" (click)="this.parent.RedirectToURL('dashboard/documents/invoices');">
      <i class="material-icons">keyboard_double_arrow_left</i>
      <span>{{ 'BackToInvoicesMenu' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintDocument(this.CurrentInvoice);" mat-raised-button class="VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
      <i class="material-icons">print</i>
      <span>{{ 'AutoPrint' | translate }}</span>
    </button>

    <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
  </div>

   <div class="PopUpBody" style="max-height: 75vh;">
      <p class="DocumentBodyCanceled" *ngIf="CurrentInvoice.DocumentStatus.ID == -1;">anulata</p>

      <table style="border: solid 1px #aaa;
      padding: 20px;
      font-weight: 400;
      margin-top: 2.5%;
      position: relative;
      margin-bottom: 2.5px;
      border-collapse: separate !important;
      border-radius: 4px;">
        <tbody>
          <tr>
            <td style="border-radius: 3px;">
              <table style="width: 100%;">
                <tbody>
                  <tr style="width: 50%;max-height: 100px;float: left;">
                    <img alt="{{this.CurrentInvoice.Company.Name}}" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath != null;" [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath" style="max-width: 50%;max-height: 100%;"/>
                    <td style="width: 75%;
                    float: left;
                    font-size: 26px;
                    font-weight: 700;
                    line-height: 30px;
                    text-transform: uppercase;" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath == null;">{{this.CurrentInvoice.Company.Name}}</td>
                  </tr>
                  <tr style="width: 50%;float: left;">
                     <table style="width: 100%;float: left;">
                       <tbody>
                        <tr style="width: 50%;float: left;font-size: 18px;font-weight: 700;text-transform: uppercase;">
                          {{CurrentInvoice.DocType.Meaning}}
                        </tr>
                        <tr style="width: 50%;float: left;text-align: right;font-weight: 700;font-size: 22px;padding-right: 5px;">
                          {{CurrentInvoice.AccountingNumber.DisplayValue}}
                        </tr>
                       </tbody>
                     </table>
        
                      <table style="width: 100%;float: left;margin-top: 10px;">
                        <tbody>
                          <tr style="width: 50%;float: left;font-size: 13px;">
                            {{ 'CreatingDate' | translate }}: {{CurrentInvoice.EventRegisterUIDate}}
                          </tr>
                          <tr style="width: 50%;float: left;text-align: right;font-size: 13px;padding-right: 5px;" *ngIf="CurrentInvoice.VATs.length == 1;">
                            {{ 'VATRate' | translate }}: <span *ngFor="let v of CurrentInvoice.VATs">{{v.Percentage}}%</span>
                          </tr>
                        </tbody>
                      </table>
        
                     <table style="width: 100%;float: left;margin-top: 10px;">
                       <tbody>
                        <tr style="width: 100%;float: left;height: 40px;background: #254a91;border-radius: 3px;line-height: 40px;text-align: right;color: #fff;font-size: 20px;font-weight: 500;">
                          <td style="float: left;width: 100%;padding: 0;">
                           <table style="width: 100%;">
                             <tbody>
                              <tr style="width: 50%;float: left;font-size: 18px;text-align: left;padding-left: 10px;text-transform: uppercase;">
                                {{ 'TotalValue' | translate }}
                              </tr>
                              <tr style="width: 50%;float: left;font-size: 18px;text-align: right;padding-right: 10px;text-transform: uppercase;">
                                <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                                <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                                <span style="font-size: 14px;"> {{CurrentInvoice.Currency.Name}}</span>
                              </tr>
                             </tbody>
                           </table>
                          </td>
                        </tr>
                       </tbody>
                     </table>
        
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                    <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                      <tr style="width: 60%;
                      float: left;
                      padding-left: 5px;
                      text-transform: uppercase;
                      font-weight: 500;
                      height: 30px;
                      line-height: 30px;
                      border-bottom: solid 2px #254a91;
                      margin-top: 10px;">{{ 'Supplier' | translate }}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-weight: 700;
                      font-size: 16px;">{{this.CurrentInvoice.Company.Name}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Company.VATNumber}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'RegCom' | translate }}: {{this.CurrentInvoice.Company.COCRegisterNr}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Company.Addresses[0].Country.Name}} 
                       {{this.CurrentInvoice.Company.Addresses[0].StateProvince}}
                       {{this.CurrentInvoice.Company.Addresses[0].City}}
                       {{this.CurrentInvoice.Company.Addresses[0].AddressLine}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{this.CurrentInvoice.Company.Banks[0]?.BankAccounts[0]?.Currency.Name}}) : {{this.CurrentInvoice.Company.Banks[0]?.BankAccounts[0]?.AccountNumber}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'Partners.PartnerWindow.Bank' | translate }}: {{this.CurrentInvoice.Company.Banks[0]?.Name}}</tr>
        
                    </td>
                  </tr>
                  <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                    <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                      <tr style="width: 60%;
                      float: left;
                      padding-left: 5px;
                      text-transform: uppercase;
                      font-weight: 500;
                      height: 30px;
                      line-height: 30px;
                      border-bottom: solid 2px #254a91;
                      margin-top: 10px;">{{ 'Client' | translate }}</tr> 
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-weight: 700;
                      font-size: 16px;">{{this.CurrentInvoice.Client.Name}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Client.VAT}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 0px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Client.BillingAddress.StateProvince}} {{this.CurrentInvoice.Client.BillingAddress.City}} {{this.CurrentInvoice.Client.BillingAddress.AddressLine}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 0px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'Country' | translate }}: {{this.CurrentInvoice.Client.BillingAddress.Country.Name}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 0px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'Login.Email' | translate }}: {{this.CurrentInvoice.Client.ContactInfo.Email}}</tr>
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;margin-top: 20px;height: 2px;background: #254a91;">
                    
                  </tr>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      {{ 'Receptions.Table.Nr' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                      {{ 'Receptions.Table.Name' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      {{ 'Receptions.Table.MU' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      {{ 'Receptions.Table.Qty' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;">
                      {{ 'Receptions.Table.Price' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;">
                      {{ 'Receptions.Table.Total' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      {{ 'Receptions.Table.VAT' | translate }}
                    </td>
                  </tr>
                  <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #254a91;">
                    
                  </tr>
        
                  <tr style="float: left;width: 100%;height: auto;min-height: 12px;padding-bottom: 10px;" *ngFor="let p of CurrentInvoice.Products; let i=index;" [ngClass]="{'GrayRow': i % 2 != 0}">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 7.5%;text-align: center;">
                      {{i + 1}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;height: auto;float: left;min-height: 12px;width: 30%;text-align: left;">
                      <p style="margin:0;margin-bottom:5px;">{{p.ProductInvoiceInfo.Name}}</p>
                      <p *ngFor="let row of p.ProductInvoiceInfo.DescriptionRows; let j=index;" style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;">
                          {{row}}
                      </p>
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                      {{p.ProductInvoiceInfo.MeasuringUnit.Name}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                      {{p.ProductInvoiceInfo.Quantity}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 17.5%;text-align: right;">
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIUnitPrice}}</span>
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIUnitPriceDiscount}}</span>
        
                      <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">
                        Discount - {{p.ProductInvoiceInfo.Price.Discount.Value}} 
                        <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">%</span>
                        <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 2;">{{this.CurrentInvoice.Currency.Name}}</span>
                      </p>
                      <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null && p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">
                        Initial - {{p.ProductInvoiceInfo.Price.UIUnitPrice}} {{this.CurrentInvoice.Currency.Name}}
                      </p>
        
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 15%;text-align: right;">
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIQtyPrice}}</span>
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIQtyPriceDiscount}}</span>
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                      <span>{{p.ProductInvoiceInfo.Price.TotalVATValue}}</span>
                    </td>
                  </tr>
        
                  <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #aaa;">
                    
                  </tr>
        
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      {{ 'InvoiceCreator' | translate }}:
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;text-transform: capitalize;">
                      {{this.CurrentInvoice.Details.Agent.Name}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                      Total:
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;background: #f6f6f6;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;background: #f6f6f6;">
                         <span>{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Integer}}</span>
                         <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Decimals}}</span> 
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                      <span>{{CurrentInvoice.Total.UITotalVAT.Integer}}</span>
                      <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalVAT.Decimals}}</span> 
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                      {{ 'TotalPayment' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                      <span> {{CurrentInvoice.Currency.Name}}</span>
                    </td>
                  
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                      {{ 'PaymentTerms' | translate }}:
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                       {{this.CurrentInvoice.PaymentDueDateUI}}
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;" *ngIf="CurrentInvoice.Details.Agent != null && CurrentInvoice.Details.Agent.ID != null && CurrentInvoice.Details.IsSignedByAgent && this.Products.length > 0;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                  
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                     
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                      <img [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.Agent?.Signature" style="height: auto;
                      width: auto;
                      max-width: 100%;
                      max-height: 100px;"/>
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                    
                    </td>
                  </tr>
                </tbody>
              </table>

              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: bold;height: auto;float: left;min-height: 30px;width: 50%;text-align: left;padding-left: 5px;">
                      {{this.CurrentInvoice.Details?.ShippingDetails?.ShippingDetailsTextUI}}
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 30px;width: 50%;text-align: left;padding-left: 5px;">
                      {{this.CurrentInvoice.Details.Observations}}
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;background: #f6f6f6;">
                <tbody>
                  <tr>
                    <td style="padding:5px;">
                      <tr style="float: left;width: 100%;height: auto;">
                        <td style="line-height: 12px;font-size: 12px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{this.CurrentInvoice.Company.Name}}
                        </td>
                      </tr>
                      <tr style="float: left;width: 100%;height: auto;">
                        <td style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{ 'Telephone' | translate }}: {{this.CurrentInvoice.Details.Agent.Phone}}; Email: {{this.CurrentInvoice.Details.Agent.Email}}
                        </td>
                      </tr>
                      <tr style="float: left;width: 100%;height: auto;" *ngFor="let b of this.CurrentInvoice.Company.Banks">
                        <td *ngFor="let a of b.BankAccounts" style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{a.Currency.Name}}) : {{a.AccountNumber}}
                        </td>
                      </tr>
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;" *ngIf="this.CurrentInvoice.Details.SignStampSubstituteRows.length > 0;">
                <tbody>
                  <tr>
                    <td style="padding:5px;">
                      <tr style="float: left;width: 100%;height: auto;" *ngFor="let row of this.CurrentInvoice.Details.SignStampSubstituteRows">
                        <td style="line-height: 11px;font-size: 11px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{row}}
                        </td>
                      </tr>
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                  
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                     
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 50%;text-align: right;padding-right: 10px;">
                      {{'DocumentGeneratedBySoftware' | translate}}: <a href="https://www.foxcloud.ro" style="color: #254a91;">www.foxcloud.ro</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
   </div>
 
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowEFacturaQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowEFacturaQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ShowEFacturaQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'ShowEFacturaQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading || this.DocumentBodyLoading" mat-raised-button class="InfoQuestionButton" (click)="ShowEFacturaQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading || this.DocumentBodyLoading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="UploadEFactura();">{{ 'Send' | translate }}</button>
  </div>
</div>

<div class="MainContainer animated fadeIn" *ngIf="!this.loading">

    <div class="overlay" *ngIf="ShowDeleteBoxQuestion || ShowShippingDetailsContainer || showAccountingSeriesError || ShowSubordronateDocumentsWarning || ShowSubordonateProductsAdjustment || ShowDocumentError || ShowProformaInvoiceConvertorQuestion || showInvoiceVisualizer || showAddNewPartnerPopUp || showEditPartnerPopUp || ShowReceptionEditProductContainer || showProductDiscountContainer || showDocumentDiscountContainer"></div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteBoxQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false;DeleteBox(CurrentBox);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="ShippingDetailsContainer animated fadeInDown" *ngIf="ShowShippingDetailsContainer == true;">
      <div class="ShippingDetailsContainerCloseIcon">
        <i class="material-icons" (click)="ShowShippingDetailsContainer = false;">close</i>
      </div>
  
      <div class="ShippingDetailsContainerTitle">{{'ShippingDetails' | translate}}</div>
  
      <div class="ShippingDetailsContainerBody">
  
        <p class="ShippingDetailsContainerBodyTitle">
          {{'GeneralShippingInformation' | translate}}
          <img *ngIf="this.CurrentInvoice.Details.ShippingDetails?.ShippingCompany?.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.ShippingDetails.ShippingCompany.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
        </p>
  
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'ShippingServiceType' | translate }}</mat-label>
          <mat-select name="ShippingServiceType" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.ShippingServiceType">
            <mat-option *ngFor="let s of this.ShippingServiceTypes" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'ShippingWay' | translate }}</mat-label>
          <mat-select name="ShippingWay" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.ShippingWay">
            <mat-option *ngFor="let s of this.ShippingWays" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'ShippingResponsability' | translate }}</mat-label>
          <mat-select name="ShippingResponsability" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.ShippingResponsability">
            <mat-option *ngFor="let s of this.ShippingResponsabilities" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
          <mat-select name="ShippingCompany" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.ShippingCompany">
            <mat-option *ngFor="let s of this.ShippingCompanies" [value]="s">
              {{s.Name}}
              <img *ngIf="s.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + s.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'WeightType' | translate }}</mat-label>
          <mat-select name="WeightType" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.WeightType">
            <mat-option *ngFor="let t of this.WeightTypes" [value]="t">
              {{t.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <p class="ShippingDetailsContainerBodyTitle">{{'TransportedBoxesInformation' | translate}}</p>
  
        <button mat-raised-button color="primary" (click)="AddNewBox();" style="margin-bottom: 10px;">{{'AddNewParcel' | translate}}</button>
  
        <div class="ParcelContainerHeadder" *ngIf="this.CurrentInvoice?.Details?.ShippingDetails?.Boxes?.length > 0;">
  
          <div class="ParcelIndexHeadder">
              <span>#</span>
          </div>
  
          <div class="ParcelDimentionHeadder">
            <span>{{ 'Length' | translate }}</span>
          </div>
  
          <i class="material-icons BetweenDimentionsX">close</i>
  
          <div class="ParcelDimentionHeadder">
            <span>{{ 'Width' | translate }}</span>
          </div>
  
          <i class="material-icons BetweenDimentionsX">close</i>
  
          <div class="ParcelDimentionHeadder">
            <span>{{ 'Height' | translate }}</span>
          </div>
  
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
  
          <div class="ParcelDimentionHeadder">
            <span>{{ 'Weight' | translate }}</span>
          </div>
  
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
  
          <div class="ParcelDimentionHeadder">
            <span>{{ 'WeightType' | translate }}</span>
          </div>
  
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
  
          <div class="ParcelDimentionHeadder" style="width: auto; max-width: 220px;">
            <span>{{ 'TrackingLabel' | translate }}</span>
          </div>
  
        </div>
  
        <div class="ParcelContainer" *ngFor="let box of this.CurrentInvoice.Details.ShippingDetails.Boxes; let j=index;" style="border-bottom: solid 1px #ddd;">
          <div class="ParcelIndex">
           <span *ngIf="box.IsPallet != true;">{{'Parcel' | translate}}</span>
           <span *ngIf="box.IsPallet == true;">{{'Pallet' | translate}}</span>
           <span>#{{j + 1}}</span>
          </div>
          
          <mat-form-field appearance="outline" class="ParcelDimention">
            <mat-label>{{ 'Length' | translate }}*</mat-label>
            <input matInput placeholder="{{'Length' | translate}}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select()">
          </mat-form-field>
  
          <i class="material-icons BetweenDimentionsX">close</i>
  
          <mat-form-field appearance="outline" class="ParcelDimention">
            <mat-label>{{ 'Width' | translate }}*</mat-label>
            <input matInput placeholder="{{'Width' | translate}}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select()">
          </mat-form-field>
  
          <i class="material-icons BetweenDimentionsX">close</i>
  
          <mat-form-field appearance="outline" class="ParcelDimention">
            <mat-label>{{ 'Height' | translate }}*</mat-label>
            <input matInput placeholder="{{'Height' | translate}}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select()">
          </mat-form-field>
  
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
  
          <mat-form-field appearance="outline" class="ParcelDimention">
            <mat-label>{{this.CurrentInvoice?.Details?.ShippingDetails?.WeightType?.Name}}*</mat-label>
            <input matInput placeholder="{{'Weight' | translate}}" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select()">
          </mat-form-field>
  
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
  
          <mat-checkbox class="PalletCheckBox" [(ngModel)]="box.IsPallet">{{'Pallet' | translate}}?</mat-checkbox>
  
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
  
          <mat-form-field appearance="outline" class="BoxTrackingLabel">
            <mat-label>{{ 'TrackingLabel' | translate }}</mat-label>
            <input matInput placeholder="{{'TrackingLabel' | translate}}" autocomplete="off" [(ngModel)]="box.TrackingLabel">
          </mat-form-field>
  
          <div class="boxStatus" *ngIf="box.ID > 0;">
            <i class="material-icons">check</i>
          </div>
  
          <div class="boxStatus">
            <i class="material-icons" style="color: red;cursor: pointer;" (click)="CurrentBox = box; ShowDeleteBoxQuestion = true;">close</i>
          </div>
        </div>
  
      </div>
      <div class="ShippingDetailsContainerCommands">
        <button *ngIf="this.CurrentInvoice.Details.ShippingDetails?.ID > 0;" mat-raised-button color="warn" style="float:left;" (click)="ShowDeleteShippingDetailsContainer = true;" matTooltipClass='neutral-tool-tip'>
          <i class="material-icons ">delete_forever</i>
        </button>
        <button mat-raised-button color="primary" style="float:right;" (click)="ShowShippingDetailsContainer = false;" matTooltip="{{ 'NoSavingAtDBLevelWarning' | translate }}" matTooltipClass='neutral-tool-tip'>OK</button>
        <button mat-raised-button color="accent" style="float:right;margin-right: 10px;" (click)="ProofShippingDetails(this.CurrentInvoice.Details.ShippingDetails, true);" matTooltip="{{ 'SaveToDBDescription' | translate }}" matTooltipClass='neutral-tool-tip'>{{'SaveToDB' | translate}}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="showAccountingSeriesError">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.AccountingSeriesDocumentError' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.AccountingSeriesDocumentErrorDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button mat-raised-button color="primary" class="InfoQuestionButton" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');"> {{ 'Configuration.GoToSettings' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowSubordronateDocumentsWarning">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowSubordronateDocumentsWarning = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Attention' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{this.SubordronateDocumentsMessage}}

        <div class="SubordronateDetectedPairs">{{'DetectedPairs' | translate}}: <span style="color: #32aa3a;">{{SalesDocumentsPairsCOUNT}}</span></div>
      </div>
  
      <div class="InfoQuestionCommands SubordronateDocumentsContainerCommands">
        <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="SubordronateDocumentsCommandButton" (click)="AddInvoice(false, true);">
          <i class="material-icons">verified</i>
          {{ 'AddWithSubordonatePairs' | translate }}
        </button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="SubordronateDocumentsCommandButton" style="background-color: #f60;" (click)="AddInvoice(true, false);">
          <i class="material-icons">dnd_forwardslash</i>
          {{ 'ContinueWithout' | translate }}
        </button>
      </div>
    </div>

    <div class="animated fadeInDown SubordonateProductsAdjustmentContainer" *ngIf="ShowSubordonateProductsAdjustment">
      <div class="PopUpCloseContainer" (click)="ShowSubordonateProductsAdjustment = false;">
        <i class="material-icons">close</i>
      </div>
    
      <div class="PopUpTitleContainer">
        <p>{{ 'SubordonateSettings' | translate }}</p>
       </div>

       <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">

        <div class="SubordonateProductAdjustmentRow" style="text-align: left;">
          <mat-slide-toggle matTooltip="{{ 'ProductSubordonateAutoAdjustSettingDesc' | translate }}" matTooltipClass='neutral-tool-tip' [(ngModel)]="ProductSubordonateAutoAdjust">{{'ProductSubordonateAutoAdjustSetting' | translate}}</mat-slide-toggle>
        </div>

        <div class="SubordonateProductAdjustmentRow" style="text-align: left;">
          <mat-slide-toggle matTooltip="{{ 'ProductSubordonateFillBacklogDifferenceSettingDesc' | translate }}" matTooltipClass='neutral-tool-tip' [(ngModel)]="ProductSubordonateFillBacklogDifference">{{'ProductSubordonateFillBacklogDifferenceSetting' | translate}}</mat-slide-toggle>
        </div>

        <div class="SubordonateProductAdjustmentRow" *ngFor="let p of this.NewProduct?.SubordonatesInfo?.Products">
          <div class="SubordonatesAdjustButton" (click)="p.ReservedAmmount = p.ReservedAmmount - 1;">-</div>
          <div class="SubordonatesAdjustButton" (click)="p.ReservedAmmount = p.ReservedAmmount + 1;">+</div>
         
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>{{p.Administration.Company.Name}}</mat-label>
            <input matInput type="number" [(ngModel)]="p.ReservedAmmount">
          </mat-form-field>
        </div>
      </div>

       <div class="PopUpCommands">
        <button [disabled]="parent.loading" mat-raised-button color="accent" matTooltip="" class="ProductsAdjustmentButton" (click)="AutoAdjustProductSubordonateQuantities(this.ProductSubordonateAutoAdjust, true);">
          <i class="material-icons">check</i>
          {{ 'Apply' | translate }}
        </button>
        <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="" class="ProductsAdjustmentButton" (click)="AutoAdjustProductSubordonateQuantities(true);">
          <i class="material-icons">autorenew</i>
          {{ 'AutoAdjust' | translate }}
        </button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowProformaInvoiceConvertorQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowProformaInvoiceConvertorQuestion = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ProformaInvoiceConversionTitle' | translate }} -  {{this.CurrentInvoice.AccountingNumber.DisplayValue}}
      </div>
      <div class="InfoQuestionBody">
        {{ 'ProformaInvoiceConversionQuestion' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowProformaInvoiceConvertorQuestion = false;">
          {{ 'Configuration.DeleteNoButton' | translate }}
        </button>
        <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton ConvertToInvoiceFromProformaButton" (click)="ConvertProformaToInvoice(CurrentInvoice.ID);">
          <i class="material-icons">domain_verification</i>
          {{ 'ConvertToInvoice' | translate }}
        </button>
      </div>
    </div>

      <div *ngIf="showAddNewPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
        <div class="PopUpCloseContainer" (click)="showAddNewPartnerPopUp = false;">
          <i class="material-icons">close</i>
        </div>
        <div class="PopUpTitleContainer">
         <p>{{ 'Partners.AddNewPartner' | translate }}</p>
        </div>
  
        <div class="PopUpBody">
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
  
          <form [formGroup]="newPartner">
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
              <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
              <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.newPartner, true);" *ngIf="this.newPartner.controls['VAT'].value != null && this.newPartner.controls['VAT'].value.length && this.newPartner.controls['Country'].value != null;">cloud_download</i>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
              <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
            </mat-form-field>
    
            <div class="PopUpBodySemiTextBox">
              <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
            </div>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
                <mat-select [(ngModel)]="newPartnerCountry" name="country" formControlName="Country" [compareWith]="compareFn" required>
                  <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="City">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
            </mat-form-field>

            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'ZipCode' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ZipCode">
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}:</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
                <mat-select [(ngModel)]="newPartnerBank" name="bank" formControlName="Bank">
                  <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                    {{b.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox" *ngIf="newPartnerBank != null;">
              <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Email' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
            </mat-form-field>
          </form>
  
        </div>
  
        <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="AddNewPartner();">{{'Partners.AddNewPartner' | translate}}</button>
        </div>
      </div>

      <div *ngIf="showEditPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
        <div class="PopUpCloseContainer" (click)="showEditPartnerPopUp = false;">
          <i class="material-icons">close</i>
        </div>
        <div class="PopUpTitleContainer">
         <p>{{ 'Partners.EditPartner' | translate }}</p>
        </div>
  
        <div class="PopUpBody">
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
  
          <form [formGroup]="currentPartner">
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
              <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
              <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.currentPartner, false);" *ngIf="this.currentPartner.controls['VAT'].value != null && this.currentPartner.controls['VAT'].value.length;">cloud_download</i>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
              <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
            </mat-form-field>
    
            <div class="PopUpBodySemiTextBox">
              <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
            </div>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
                <mat-select name="country" [compareWith]="compareFn" formControlName="Country" required>
                  <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="City" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
            </mat-form-field>

            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'ZipCode' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ZipCode">
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
                <mat-select name="bank" [compareWith]="compareFn" formControlName="Bank">
                  <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                    {{b.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Email' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
            </mat-form-field>
          </form>
  
        </div>
  
        <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="UpdatePartner();">{{'UpdatePartner' | translate}}</button>
        </div>
      </div>

      <div class="animated fadeInDown ReceptionEditProductContainer" *ngIf="ShowReceptionEditProductContainer">
        <div class="PopUpCloseContainer" (click)="ShowReceptionEditProductContainer = false;RevertProduct();">
          <i class="material-icons">close</i>
        </div>
        <div class="ReceptionEditProductTitleContainer">
         <p>
          <i class="material-icons titleModificationIcon">build</i>
           {{CurrentProduct.ProductInvoiceInfo.Name}}
          </p>
        </div>
  
        <div class="PopUpBody" *ngIf="!loadingEditProduct">
          <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID == null;">
            <div class="PopUpBodyTwoThirdsContainer">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Administration">
                  <mat-option *ngFor="let a of this.Administrations;" [value]="a">
                    {{a.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.GeneralType">
                  <mat-option *ngFor="let t of this.ProductGeneralTypes" [value]="t" (onSelectionChange)="chanveNewProductVALUE($event);">
                    {{t.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
          </div>

          <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID != null;">
            <div class="PopUpBodyTwoThirdsContainer">
              <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                <input disabled="disabled" matInput placeholder="{{ 'Receptions.Administration' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Administration.Name">
              </mat-form-field>
            </div>
  
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                <input disabled="disabled" matInput placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.GeneralType.Name">
              </mat-form-field>
            </div>
  
          </div>
         
          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyTwoThirdsContainer">
              <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                <mat-label>{{ 'Receptions.Table.Name' | translate }}</mat-label>
                <input matInput placeholder="{{ 'Receptions.Table.Name' | translate }}" (click)="SearchProductsInvoicingInformation(CurrentProduct.ProductInvoiceInfo.Name, CurrentProduct.ProductInvoiceInfo.Administration.ID, true);showhideSearches(true);" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsInvoicingInformation(CurrentProduct.ProductInvoiceInfo.Name, CurrentProduct.ProductInvoiceInfo.Administration.ID, true);">
                <mat-icon matSuffix style="cursor: pointer;" *ngIf="ProductsSearchResultsCOUNTPop == 0 && !loadingSearchProducts && CurrentProduct.ProductInvoiceInfo.Name.length == 0;">search</mat-icon>
                <mat-icon matSuffix style="cursor: pointer;" *ngIf="(ProductsSearchResultsCOUNTPop > 0 || CurrentProduct.ProductInvoiceInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</mat-icon>
              </mat-form-field>
              <div class="SpinnerIconContainerPopUp" *ngIf="loadingSearchProducts">
                <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
              </div>
            </div>
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                <mat-label>{{ 'Receptions.Table.Code' | translate }}</mat-label>
                <input disabled *ngIf="CurrentProduct.ProductInvoiceInfo.ProductID != null;"matInput placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Code">
                <input *ngIf="CurrentProduct.ProductInvoiceInfo.ProductID == null;" matInput placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Code">
              </mat-form-field>
            </div>
            <div class="ProductsSearchResultsContainer ProductsSearchResultsContainerPopException" *ngIf="ProductsSearchResultsCOUNTPop > 0 && showSearchCurrent;">
              <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResultsPop" (click)="SelectReceptionProductFromSearchCurrent(p);">
                  <p class="ProductSearchResultTitle">{{p.Name}}</p>
              </div>
            </div>
          </div>

          <div class="PopUpBodyRowContainer">
              <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                    <mat-label>{{ 'Description' | translate }}</mat-label>
                    <textarea autocomplete="off" matInput
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10"
                              [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Description"></textarea>
                  </mat-form-field>
              </div>
          </div>
  
          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.Table.MU' | translate }}</mat-label>
                <mat-select name="MeasuringUnit" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.MeasuringUnit">
                  <mat-option *ngFor="let u of this.MeasuringUnits" [value]="u">
                    {{u.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                <mat-label>{{ 'Receptions.Table.Qty' | translate }}</mat-label>
                <input matInput placeholder="{{ 'Receptions.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Quantity">
              </mat-form-field>
            </div>
            <div class="PopUpBodyOneThirddContainer">
             
            </div>
          </div>
  
          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                <mat-label>{{ 'Receptions.Table.PriceNOVAT' | translate }}</mat-label>
                <input [disabled]="CurrentProduct.ProductInvoiceInfo.PriceContainsVAT" matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice" (change)="VerifyPriceModel(CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice);">
              </mat-form-field>
            </div>
  
             <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                <mat-label>{{ 'Receptions.Table.PriceVAT' | translate }}</mat-label>
                <input [disabled]="!CurrentProduct.ProductInvoiceInfo.PriceContainsVAT" matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice" (change)="VerifyPriceModel(CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice);">
              </mat-form-field>
            </div>
  
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.Table.VAT' | translate }}</mat-label>
                <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.VAT">
                  <mat-option *ngFor="let v of this.VATRates" [value]="v" (click)="ModifyReceptionProduct(true);">
                    {{v.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          
          </div>
  
          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyOneThirddContainer">
              <mat-slide-toggle (change)="priceContainsVATchanged($event)" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.PriceContainsVAT">{{ 'Receptions.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
            </div>
          </div>
  
          <div class="DiscountRow" *ngIf="CurrentProduct.ProductInvoiceInfo.Price.Discount != null && CurrentProduct.ProductInvoiceInfo.Price.Discount.Value != null && CurrentInvoice.Total.Discount.Value == null;">
  
            <p class="DiscountRowTitle">
              {{CurrentProduct.ProductInvoiceInfo.Price.Discount.Type.Name}} Discount - {{CurrentProduct.ProductInvoiceInfo.Price.Discount.Value}}
              <span *ngIf="CurrentProduct.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">%</span>
              <span> ({{currency.Name}})</span>
            </p>
  
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="ReceptionProductsColSearch">
                <mat-label>{{ 'Receptions.Table.PriceNOVAT' | translate }}</mat-label>
                <input [disabled]="true" matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.UIUnitPriceDiscount">
              </mat-form-field>
            </div>
  
             <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="ReceptionProductsColSearch">
                <mat-label>{{ 'Receptions.Table.PriceVAT' | translate }}</mat-label>
                <input [disabled]="true" matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPriceDiscount">
              </mat-form-field>
            </div>
  
              <div class="PopUpBodyRowContainer">
               <button mat-button color="warn" (click)="EliminateProductDiscount();">
                <i class="material-icons buttonIcon">close</i>
                {{ 'Receptions.EliminateDiscount' | translate }}
               </button>
              </div>
          </div>
  
        </div>
  
        <div class="PopUpBody" *ngIf="loadingEditProduct">
          <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
        </div>
  
        <div class="PopUpCommands">
          <button mat-raised-button color="primary" class="ReceptionEditProductSaveButton" (click)="ModifyReceptionProduct();">
            <i class="material-icons buttonIcon">check</i>
            {{'ModifyProduct' | translate}}
          </button>
        </div>
      </div>

      <div class="animated fadeInDown DiscountContainer" *ngIf="showProductDiscountContainer">
        <div class="PopUpCloseContainer" (click)="showProductDiscountContainer = false;">
          <i class="material-icons">close</i>
        </div>
      
        <div class="PopUpTitleContainer">
          <p>{{ 'Receptions.MenuDiscount' | translate }}</p>
         </div>
  
         <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">
  
          <mat-form-field class="example-full-width discountTextBox" appearance="outline">
            <mat-label>{{ 'Receptions.DiscountType' | translate }}</mat-label>
            <mat-select name="discounts" [compareWith]="compareFn" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.Discount.Type">
              <mat-option *ngFor="let d of this.DiscountTypes" [value]="d" (onSelectionChange)="chanveNewProductVALUE($event);">
                {{d.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field class="example-full-width discountTextBox" appearance="outline">
            <mat-label>{{ 'Receptions.DiscountValue' | translate }}</mat-label>
            <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
            <input autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.Discount.Value" matInput placeholder="{{ 'Receptions.DiscountValue' | translate }}">
          </mat-form-field>
  
        </div>
  
         <div class="PopUpCommands">
          <button (click)="ApplyDiscount();" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="{{ 'Receptions.ApplyDiscount' | translate }}" class="PopGeneralCommandButton">{{ 'Receptions.ApplyDiscount' | translate }}</button>
        </div>
      </div>

      <div class="animated fadeInDown DiscountContainer" *ngIf="showDocumentDiscountContainer">
        <div class="PopUpCloseContainer" (click)="showDocumentDiscountContainer = false;">
          <i class="material-icons">close</i>
        </div>
      
        <div class="PopUpTitleContainer">
          <p>{{ 'Receptions.DocDiscount' | translate }}</p>
         </div>
  
         <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">
  
          <mat-form-field class="example-full-width discountTextBox" appearance="outline">
            <mat-label>{{ 'Receptions.DiscountType' | translate }}</mat-label>
            <mat-select name="discounts" [compareWith]="compareFn" [(ngModel)]="CurrentInvoice.Total.Discount.Type">
              <mat-option *ngFor="let d of this.DiscountTypes" [value]="d">
                {{d.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field class="example-full-width discountTextBox" appearance="outline">
            <mat-label>{{ 'Receptions.DiscountValue' | translate }}</mat-label>
            <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
            <input autocomplete="off" [(ngModel)]="CurrentInvoice.Total.Discount.Value" matInput placeholder="{{ 'Receptions.DiscountValue' | translate }}">
          </mat-form-field>
  
        </div>
  
         <div class="PopUpCommands">
          <button (click)="ApplyInvoiceDiscount();" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="{{ 'Receptions.ApplyDiscount' | translate }}" class="PopGeneralCommandButton">{{ 'Receptions.ApplyDiscount' | translate }}</button>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentInvoice?.Details?.ForceDocumentClosing == true && this.CurrentInvoice?.DocumentStatus?.ID == 1;">
        <div class="TopValueBanner"  [ngClass]="{'CollectedStatusPopUp': this.CurrentInvoice.DocumentStatus.ID == 1}">
          <div>
            {{CurrentInvoice.DocumentStatus.Name}} {{'ForcedDocumentClose' | translate}} 
            <i class="material-icons TopValueBannerIcon">verified</i>
          </div>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentInvoice.Details?.CashCollectionRemainingValue != undefined && this.CurrentInvoice.ID?.length > 0;">
        <div *ngIf="this.CurrentInvoice.DocumentStatus.ID != 2;" class="TopValueBanner"  [ngClass]="{'CollectedStatusPopUp': this.CurrentInvoice.Details.CashCollectionRemainingValue == 0, 'OverduePopUp': this.CurrentInvoice.Details.CashCollectionRemainingValue != 0 && this.CurrentInvoice.DocumentStatus.ID == 5}">
         <div *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue != 0">
          {{'RemainingToCashCollect' | translate}}: 
          <span class="TopValueBannerValue">{{this.CurrentInvoice.Details.CashCollectionRemainingValue}} {{currency.Name}}</span>
          <i class="material-icons TopValueBannerIcon">money_off_csred</i>
          <i *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue == 0" class="material-icons TopValueBannerIcon">verified</i>
         </div>
         <div *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue == 0">
          {{this.CurrentInvoice.DocumentStatus.Name}}
          <i class="material-icons TopValueBannerIcon">verified</i>
         </div>
        </div>

        <div *ngIf="this.CurrentInvoice.DocumentStatus.ID == 2;" class="TopValueBanner" style="background: #ffebcc;">
          {{'OverCollected' | translate}}
          <span class="TopValueBannerValue">{{this.CurrentInvoice.Details.CashCollectionRemainingValue}} {{currency.Name}}</span>
          <i class="material-icons TopValueBannerIcon" style="color: #f60;">verified</i>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentInvoice.ID?.length > 0;">

        <div class="TopValueBanner" style="background: #efdc75;opacity: 0.75;">
          <span style="color: #f60;">{{'ClosedDocumentModificationWarning' | translate}}</span>
          <i class="material-icons TopValueBannerIcon" style="color: #f60;">lightbulb</i>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID > 0;">

        <div class="TopValueBanner" style="background: #ddd;opacity: 0.75;">
          <span style="color: #000;">{{'LockedByEFactura' | translate}}</span>
          <i class="material-icons TopValueBannerIcon" style="color: #000;">lock_outline</i>
        </div>
      </div>

      <div class="MainTitleBar">
        <p class="SectionTitle" style="margin-top: 0%;border-bottom: solid 1px #ddd;" *ngIf="this.CurrentInvoice.ID == null;">
          <span *ngIf="!IsStorno;">{{ 'NewInvoice' | translate }}</span>
          <span *ngIf="IsStorno;">{{ 'NewStornoInvoice' | translate }}</span>
          <span class="DocumentMainCurrencyTopValue">{{currency.Name}}</span>
        </p>

        <p class="SectionTitle ProformaTitle" *ngIf="this.CurrentInvoice.DocType?.ID == 1;">
          <span>{{ 'Proforma' | translate }}</span>
        </p>

        <p class="SectionTitle AdvanceInvoiceTitle" *ngIf="this.CurrentInvoice.DocType?.ID == 2;">
          <span>{{ 'AdvanceInvoice' | translate }}</span>
        </p>

        <p class="SectionTitle" style="margin-top: 0%;border-bottom: solid 1px #ddd;" *ngIf="this.CurrentInvoice?.ID != null;">
          <span *ngIf="!IsStorno;">{{ 'ModifyInvoice' | translate }} </span>
          <span *ngIf="IsStorno;">{{ 'Receptions.ModifyStorno' | translate }} </span> 
          <span class="InvoiceDisplayValue">{{this.CurrentInvoice.AccountingNumber.DisplayValue}}</span>
          <span class="DocumentMainCurrencyTopValue">{{currency.Name}}</span>
          </p>
    </div>

    <div class="MainBody animated fadeIn">
        <div class="NewReceptionBodyRow">
            <div class="PartnerSearchContainer">
                <mat-form-field appearance="outline" style="width: 100%;padding: 0;" (click)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);">
                    <mat-label>{{ 'SearchClient' | translate }}*</mat-label>
                    <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.partner = Partners[0];resultsLength = 0;this.searchTerm='';AdjustLanguageOnPartnerSeleciton();AdjustCurrencyOnPartnerSeleciton();AdjustPaymentTermOnPartnerSelect(Partners[0].ID);TestDocumentValidity();">
                    <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;">search</mat-icon>
                    <i class="material-icons addNewPartnerButton" *ngIf="!this.searchTerm" (click)="showAddNewPartnerPopUp = true;initializeAddPartnerForm();">person_add</i>
                    <i class="material-icons addNewPartnerButton" style="color: red;border:none;" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0;">close</i>
                  </mat-form-field>
    
                  <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                    <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm='';AdjustLanguageOnPartnerSeleciton();AdjustCurrencyOnPartnerSeleciton();AdjustPaymentTermOnPartnerSelect(p.ID);TestDocumentValidity();">
                        <p class="SearchResultTitle DottedRow">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length;">{{p.VAT}}</span></p>
                    </div>
                  </div>
    
                  <div class="PartnerInfoContainer" *ngIf="partner != null">
                    <i class="material-icons PartnerInfoContainerEUVerified" matTooltip="EU Verified" *ngIf="partner.EUVATVerified">verified_user</i>
                    <p class="PartnerInfoTitle">{{partner.Name }} 
                        <i *ngIf="partner.ID != null;" class="material-icons PartnerDeleteIcon" (click)="partner = null;TestDocumentValidity();">close</i>
                        <i *ngIf="partner.ID != null;" class="material-icons PartnerEditIcon" (click)="initializePartnerFormFromObject(partner);">edit</i>
                        <i *ngIf="partner.ID == null;" class="material-icons PartnerEditIcon" (click)="InsertPartnerFromCloud(partner);">cloud_download</i>
                    </p>
                    <span class="PartnerInfoSubTitle" *ngIf="partner.VAT?.length;">{{partner.VAT}} | </span>
                    <span class="PartnerInfoSubTitle" *ngIf="partner.COCRegNumber?.length;">{{partner.COCRegNumber}}</span>
                    <p class="PartnerInfoSubTitle">{{partner.BillingAddress.Country.ShortName}}, {{partner.BillingAddress.StateProvince}}, {{partner.BillingAddress.City}},| {{partner.BillingAddress.AddressLine}}</p>
                  </div>
            </div>
           
            <div class="newReceptionInputContainer" style="width: 40%;">
                <mat-form-field appearance="outline" class="fullWidthContainer">
                    <mat-label>{{ 'Receptions.DocumentDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="dp" [formControl]="DocumentDate" [(ngModel)]="CurrentInvoice.DocumentDate" (dateChange)="TestDocumentValidity();GetDateByPaymentTerm(CurrentInvoice.PaymentTerm);">
                    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                    <mat-datepicker #dp></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field style="width: 38%;margin-left: 2%;" appearance="outline">
                    <mat-label>{{ 'PaymentTerms' | translate }}</mat-label>
                    <mat-select name="Series" [compareWith]="compareFn" [(ngModel)]="CurrentInvoice.PaymentTerm">
                      <mat-option *ngFor="let term of this.PaymentTerms" [value]="term" (click)="GetDateByPaymentTerm(term);">
                        {{term.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
    
                  <mat-form-field appearance="outline" class="threeThirdsContainer">
                    <mat-label>{{ 'Receptions.DueDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="dp1" [formControl]="PaymentDueDate" [(ngModel)]="CurrentInvoice.PaymentDueDate" (dateChange)="TestDocumentValidity();CurrentInvoice.PaymentTerm = null;">
                    <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                    <mat-datepicker #dp1></mat-datepicker>
                  </mat-form-field>
            </div>

            <div class="newReceptionInputContainer" style="width: 15%;">

                <mat-form-field style="width: 100%;" appearance="outline" *ngIf="CurrentInvoice.AccountingNumber?.ID == null;">
                    <mat-label>{{ 'Receptions.Series' | translate }}</mat-label>
                    <mat-select name="Series" [compareWith]="compareFn" [(ngModel)]="CurrentInvoice.AccountingNumber.AccountingSeries">
                      <mat-option *ngFor="let series of this.AccountingSeries" [value]="series">
                        {{series.Series}} (nr.XXXX)
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field style="width: 100%;" appearance="outline" *ngIf="CurrentInvoice.AccountingNumber?.ID != null;">
                    <mat-label>{{ 'Receptions.Series' | translate }}</mat-label>
                    <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.CurrentInvoice.AccountingNumber.DisplayValue" disabled="disabled">
                  </mat-form-field>

                  <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>{{ 'Receptions.Currency' | translate }}</mat-label>
                    <mat-select name="currency" [compareWith]="compareFn" [(ngModel)]="currency">
                      <mat-option *ngFor="let c of this.Currencies" [value]="c" (click)="GetCurrencyLiveExchange(c);">
                        {{c.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div class="ReceptionSelectedCurrency" *ngIf="currency != null && currency.ExchangeRate > 0;">
                    <mat-form-field class="example-full-width ReceptionExchangeInput">
                        <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
                        <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
                        <input [(ngModel)]="currency.ExchangeRate" matInput placeholder="Exchange">
                      </mat-form-field>
                  </div>
            </div>

            <div class="newReceptionInputContainer" style="width: 15%;">
                <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                    <mat-select name="DocType" [compareWith]="compareFn" [(ngModel)]="InvoicePrecision">
                      <mat-option *ngFor="let p of this.DecimalPrecisions" [value]="p" (click)="AdjustProductsDecimalPrecisionPrice();">
                        {{p.Meaning}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>{{ 'Language' | translate }}</mat-label>
                    <mat-select name="Languages" [compareWith]="compareFn" [(ngModel)]="CurrentInvoice.Language">
                      <mat-option *ngFor="let lang of this.Languages" [value]="lang">
                        {{lang.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
        </div>

        <div class="ReceptionProductsContainer">
            <div class="ReceptionProductsRow" style="padding-top: 10px;border: none;">
                <div class="ReceptionProductsCol" style="width: 15%;">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" *ngIf="NewProduct?.ID == null;">
                        <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                        <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductInvoiceInfo.Administration">
                          <mat-option *ngFor="let a of this.Administrations;" [value]="a" (onSelectionChange)="chanveNewProductVALUE($event);" (click)="SearchProductsInvoicingInformation(NewProduct.ProductInvoiceInfo.Name, a.ID, false);">
                            {{a.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="ReceptionProductsColSearch" *ngIf="NewProduct?.ID != null;">
                        <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                        <input disabled="disabled" matInput placeholder="{{ 'Receptions.Administration' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Administration.Name">
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;text-align: left;">
                    <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                        <mat-label>{{ 'Receptions.Table.Name' | translate }}</mat-label>
                        <input (click)="this.productSearchTermUpdate.next($event); showhideSearches(false);" matInput placeholder="{{ 'Receptions.Table.Name' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); this.productSearchTermUpdate.next($event);" (keydown.enter)="SelectReceptionProductFromSearch(ProductsSearchResults[0]);">
                        <mat-icon matSuffix style="cursor: pointer;" *ngIf="ProductsSearchResultsCOUNT == 0 && !loadingSearchProducts && NewProduct.ProductInvoiceInfo.Name.length == 0;">search</mat-icon>
                        <mat-icon matSuffix style="cursor: pointer;" *ngIf="(ProductsSearchResultsCOUNT > 0 || NewProduct.ProductInvoiceInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</mat-icon>
                      </mat-form-field>
                      <div class="SpinnerIconContainer" *ngIf="loadingSearchProducts">
                        <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
                      </div>
                      <div class="PartnerStockInfo" *ngIf="this.NewProduct?.SubordonatesInfo?.AvailableQuantity > 0;">
                        <p style="color: #f60;">
                          {{this.NewProduct?.SubordonatesInfo?.AvailableQuantity}} {{'PiecesInPartnerStock' | translate}}
                        </p>
                        <p *ngFor="let c of this.NewProduct?.SubordonatesInfo.Companies;" style="color: #32aa3a;">
                          {{c.Name}}
                        </p>
                        <button mat-raised-button color="primary" class="SubordonateButton" (click)="OpenSubordonateProductsAdjustment();">
                          <i class="material-icons">settings_ethernet</i>
                        </button>
                      </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                        <mat-label>{{ 'Receptions.Table.Code' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Code" (ngModelChange)="chanveNewProductVALUE($event); this.productSearchTermUpdate.next($event);"  matTooltip="{{NewProduct.ProductInvoiceInfo.Code}}" matTooltipClass='purchase-tool-tip'>
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{ 'Receptions.Table.MU' | translate }}</mat-label>
                        <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductInvoiceInfo.MeasuringUnit">
                          <mat-option *ngFor="let u of this.MeasuringUnits" [value]="u" (selectionChange)="chanveNewProductVALUE($event);">
                            {{u.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                        <mat-label>{{ 'Receptions.Table.Qty' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Receptions.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Quantity" (ngModelChange)="chanveNewProductVALUE($event);CheckAndGetProductSubordonates(NewProduct);">
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                    <mat-form-field appearance="outline" class="ReceptionProductsColSearch" *ngIf="!NewProductPriceContainsVAT">
                        <mat-label>{{ 'Receptions.Table.Price' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Price.UIUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductInvoiceInfo.Price.UIUnitPrice);">
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="ReceptionProductsColSearch" *ngIf="NewProductPriceContainsVAT">
                        <mat-label>{{ 'Receptions.Table.Price' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice);">
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 12.5%;">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                    <mat-label>{{ 'Receptions.Table.VAT' | translate }}</mat-label>
                    <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductInvoiceInfo.Price.VAT">
                      <mat-option *ngFor="let v of this.VATRates" [value]="v" (click)="chanveNewProductVALUE($event);">
                        {{v.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                  <button [disabled]="!IsValidNewProduct" mat-raised-button color="primary" class="ReceptionProductsAddButton" (click)="AddProductToInvoice();">
                    <i class="material-icons">add</i>
                    <span>{{ 'Receptions.Table.AddToReception' | translate }}</span>
                </button>
                </div>

                <div class="ProductsSearchResultsContainer" *ngIf="ProductsSearchResultsCOUNT > 0 && showSearch;">
                  <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResults" (click)="SelectReceptionProductFromSearch(p);" [ngClass]="{'SearchResultPoolProductAlert': p.IsFromPool}">
                    <p class="ProductSearchResultTitle">{{p.Name}} 
                      <span *ngIf="p.DiscrepancyAmmount != null;" class="DiscrepancyAmmountSpan" [ngClass]="{'MinusDiscrepancyAmmount': p.DiscrepancyAmmount < 0, 'NormalDiscrepancyAmmount': p.DiscrepancyAmmount >= 0}">{{p.DiscrepancyAmmount}}
                        <span *ngIf="p.DiscrepancyAmmount < 0;"> {{'MissingStockValue' | translate}}</span>
                        <span *ngIf="p.DiscrepancyAmmount >= 0;"> {{'StockValue' | translate}}</span>
                      </span>
                    </p>
                    <p class="ProductSearchResultType">[{{p.Code}}] [{{p.GeneralType.Name}}] <span *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</span></p>
                  </div>
                </div>

            </div>

            <div class="ReceptionProductsRow" style="border: none;">
              <div class="ReceptionProductsCol" style="width: 15%;margin-top: 5px;">

              </div>
              <div class="ReceptionProductsCol" style="width: 35%;text-align: left;">
                <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                  <mat-label>{{ 'Description' | translate }}</mat-label>
                  <textarea autocomplete="off" matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="10"
                            [(ngModel)]="NewProduct.ProductInvoiceInfo.Description"></textarea>
                </mat-form-field>
              </div>
              <div class="ReceptionProductsCol">
                 
              </div>
              <div class="ReceptionProductsCol">
                 
              </div>
              <div class="ReceptionProductsCol" style="width: 5%;">
                
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                 
              </div>
              <div class="ReceptionProductsCol" style="width: 30%;text-align: right;padding-right: 20px;">
                
              </div>
          </div>

            <div class="ReceptionProductsRow" style="height: 50px;border: none;">
                <div class="ReceptionProductsCol" style="width: 15%;margin-top: 5px;">
                    <mat-slide-toggle [(ngModel)]="NewProductPriceContainsVAT"(change)="priceContainsVATchanged($event);">{{ 'Receptions.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;text-align: left;">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" *ngIf="NewProduct.ID == null;">
                    <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                    <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="NewProduct.GeneralType">
                      <mat-option *ngFor="let t of this.ProductGeneralTypes" [value]="t" (onSelectionChange)="chanveNewProductVALUE($event);">
                        {{t.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="ReceptionProductsColSearch" *ngIf="NewProduct.ID != null;">
                    <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                    <input disabled="disabled" matInput placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.GeneralType.Name">
                  </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                 
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                   
                </div>
                <div class="ReceptionProductsCol">
                   
                </div>
                <div class="ReceptionProductsCol">
                   
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                   
                </div>
                <div class="ReceptionProductsCol" style="width: 30%;text-align: right;padding-right: 20px;">
                  {{ 'TotalProducts' | translate }}: {{this.Products.length}}
                </div>
            </div>

            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
                <div class="ReceptionProductsCol">
                    {{ 'Receptions.Table.Nr' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Receptions.Administration' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                    {{ 'Receptions.Table.Name' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.Code' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.MU' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.Qty' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                    {{ 'Receptions.Table.Price' | translate }}  ({{currency.Name}})
                </div>
                <div class="ReceptionProductsCol" style="width: 12.5%;">
                    {{ 'Receptions.Table.Total' | translate }} ({{currency.Name}})
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.VAT' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  
                </div>
            </div>

            <div [ngClass]="{'NewProductAlertColor': p.ID == null || p.ID == 0, 'PoolProductAlert': p.IsFromPool}" class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let p of this.Products; let i=index;" (dblclick)="OpenReceptionEditProduct(p.ProductInvoiceInfo.UIID);CurrentIndexProduct = i;">
              <div class="ReceptionProductsCol">
                  <p>{{i + 1}}</p>
                  <i [ngClass]="{'purchaseInfoIconIncomplete': p.ProductInvoiceInfo.PurchaseInfo?.Status.ID === -1}" class="material-icons purchaseInfoIcon" *ngIf="p.ProductInvoiceInfo.PurchaseInfo?.UIText?.length > 0;" matTooltip="{{p.ProductInvoiceInfo.PurchaseInfo?.UIText}}" matTooltipClass='purchase-tool-tip'>info</i>
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                  <p>{{p.ProductInvoiceInfo.Administration.Name}}</p>
                  <p class="NewProductAlert" *ngIf="p.ID == null || p.ID == 0;">[{{'NewProduct' | translate}}]</p>
                  <p class="PoolProductAlertRow" *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</p>
              </div>
              <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                <p>{{p.ProductInvoiceInfo.Name}}</p>
                <p class="ProductsDescriptionRow" *ngFor="let row of p.ProductInvoiceInfo.DescriptionRows; let j=index;">
                    {{row}}
                </p>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                <p>{{p.ProductInvoiceInfo.Code}}</p>
                <p class="ReceptionProductsColDesc">{{p.ProductInvoiceInfo.GeneralType.Name}}</p>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{p.ProductInvoiceInfo.MeasuringUnit.Name}}
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{p.ProductInvoiceInfo.Quantity}}
                <p class="SubordonateExtractInfoRow" *ngIf="p.SubordonatesInfo?.TotalReservedQuantity > 0;">{{'FromPartners' | translate}}: {{p.SubordonatesInfo.TotalReservedQuantity}}</p>
                <div class="AdvancePaymentRow" *ngIf="this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
                  <span *ngIf="p.ProductInvoiceInfo.Price.UIUnitPriceAdvance != null;">{{'Advance' | translate}} ({{this.CurrentInvoice.AdvancePaymentPercentage}}%):</span>
                </div>
              </div>
              <div class="ReceptionProductsCol" style="width: 15%;">
                <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIUnitPrice}}</span>
                <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIUnitPriceDiscount}}</span>

                <div class="AdvancePaymentRow" *ngIf="this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
                  <span *ngIf="p.ProductInvoiceInfo.Price.UIUnitPriceAdvance != null;">{{p.ProductInvoiceInfo.Price.UIUnitPriceAdvance}}</span>
                </div>
              </div>
              <div class="ReceptionProductsCol" style="width: 12.5%;">
                <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIQtyPrice}}</span>
                <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIQtyPriceDiscount}}</span>

                <div class="AdvancePaymentRow" *ngIf="this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
                  <span *ngIf="p.ProductInvoiceInfo.Price.UIQtyPriceAdvance != null;">{{p.ProductInvoiceInfo.Price.UIQtyPriceAdvance}}</span>
                </div>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                <span>{{p.ProductInvoiceInfo.Price.TotalVATValue}}</span>

                <div class="AdvancePaymentRow" *ngIf="this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
                  <span *ngIf="p.ProductInvoiceInfo.Price.TotalVATValueAdvance != null;">{{p.ProductInvoiceInfo.Price.TotalVATValueAdvance}}</span>
                </div>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                <i class="material-icons ReceptionProductEdit" (click)="OpenReceptionEditProduct(p.ProductInvoiceInfo.UIID);CurrentIndexProduct = i;">edit</i>
                <div class="ReceptionProductEdit" (click)="OpenProductDiscountContainer(p);CurrentIndexProduct = i;" *ngIf="CurrentInvoice.Total.Discount != undefined && CurrentInvoice.Total.Discount.Value == null;">%</div>
                <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="DeleteAuxProduct(p.ProductInvoiceInfo.UIID);TestDocumentValidity();">close</i>
              </div>
              
              <div style="margin-left: 0%;margin-right: unset;float: left;background: #ddf4b9;cursor: pointer;" class="ProductDiscountRow" *ngIf="p.ProductInvoiceInfo.GeneralType.ID != 1 && p.ProductInvoiceInfo.GeneralType.IsTaxConsumed == true;" (click)="OpenProductTaxDivision(p.ProductInvoiceInfo.UIID);">
                <p>
                  {{ 'Receptions.Consumed' | translate }}
                </p>
                <p>
                  ({{p.ProductInvoiceInfo.GeneralType.TaxDivisionType.Name}})
                </p>
              </div>

              <div class="ProductDiscountRow" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">
                  <p>
                    Discount - {{p.ProductInvoiceInfo.Price.Discount.Value}}
                    <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">%</span>
                    <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 2;">{{currency.Name}}</span>
                  </p>
              </div>

          </div>

          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length;">
            <div class="ReceptionProductsCol">
               
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
             
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              Total:
            </div>
            <div class="ReceptionProductsCol" style="width: 12.5%;">
              {{this.CurrentInvoice.Total.TotalQtyPriceNOVAT}}
              <p *ngIf="CurrentInvoice.PurchaseStatus?.ID == 1;">
                <!-- <i class="material-icons purchaseInfoIcon" matTooltip="{{'PurchasePrice' | translate}}: {{CurrentInvoice.Total.UITotalPurchaseCost.Integer}}{{CurrentInvoice.Total.UITotalPurchaseCost.Decimals}} {{this.CurrentInvoice.Currency.Name}}" matTooltipClass='purchase-tool-tip'>info</i> -->
                <i class="material-icons purchaseInfoIcon" matTooltip="{{this.CurrentInvoice.Total.TotalPurchaseInfoUIText}}" matTooltipClass='purchase-tool-tip'>info</i>
              </p>
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{this.CurrentInvoice.Total.TotalVAT}}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{this.CurrentInvoice.Total.TotalQtyPriceVAT}}
            </div>
        </div>

        <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length && this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
          <div class="ReceptionProductsCol">
             
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
           
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 15%;">
            <div class="AdvancePaymentRow">
              Total {{'Advance' | translate}} ({{this.CurrentInvoice.AdvancePaymentPercentage}}%):
            </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 12.5%;">
            <div class="AdvancePaymentRow">
              {{this.CurrentInvoice.TotalAdvance.TotalQtyPriceNOVAT}}
            </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            <div class="AdvancePaymentRow">
              {{this.CurrentInvoice.TotalAdvance.TotalVAT}}
            </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            <div class="AdvancePaymentRow">
              {{this.CurrentInvoice.TotalAdvance.TotalQtyPriceVAT}}
            </div>
          </div>
      </div>

        <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length;">
          <div class="ReceptionProductsCol" style="width: 15%;">
            <button mat-button color="warn" (click)="EliminateDocumentDiscount();" *ngIf="CurrentInvoice.Total.Discount != null && CurrentInvoice.Total.Discount.Value != null">
              <i class="material-icons buttonIcon">close</i>
              {{ 'Receptions.EliminateDiscount' | translate }}
             </button>
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 15%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 15%;">
            <div class="ProductGeneralDiscountRow" *ngIf="CurrentInvoice.Total.Discount != null && CurrentInvoice.Total.Discount.Value != null">
              <p style="padding-top: 0px;line-height: 35px;overflow: hidden;">
                Discount - {{CurrentInvoice.Total.Discount.Value}}
                <span *ngIf="CurrentInvoice.Total.Discount.Type.ID == 1;">%</span>
                <span *ngIf="CurrentInvoice.Total.Discount.Type.ID == 2;">{{currency.Name}}</span>
              </p>
          </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 27.5%;text-align: right;padding-right: 10px;">
            <button mat-button color="primary" (click)="OpenDocumentDiscountContainer();">{{ 'Receptions.DocDiscount' | translate }} %</button>
          </div>
      </div>

        </div>

        <div class="ReceptionBottomCommands">

          <div class="BottomCommandsOverlay" *ngIf="!ValidDocument;"></div>

          <div class="PopUpBodyRowContainer">
            <mat-form-field class="PopUpBodyOneThirddContainer" appearance="outline" *ngIf="CurrentInvoice.DocType.ID == 2;">
              <mat-label>{{ 'AdvancePaymentPercentage' | translate }}</mat-label>
              <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.CurrentInvoice.AdvancePaymentPercentage" (change)="ImplementAdvancePaymentValues();">
            </mat-form-field>
          </div>

          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyOneThirddContainer" style="padding-left: 10px;">
              <div class="PopUpBodyRowContainer">
                <mat-checkbox [(ngModel)]="CurrentInvoice.Details.StockDischarging">{{ 'DischargeStocks' | translate }}</mat-checkbox>
              </div>
              <div class="PopUpBodyRowContainer">
                <mat-checkbox [(ngModel)]="CurrentInvoice.Details.IsSignedByAgent">{{ 'IsSignedByAgent' | translate }}</mat-checkbox>
              </div>
            </div>
            <div class="PopUpBodyOneThirddContainer">
               <div class="PopUpBodyRowContainer animated fadeIn" *ngIf="CurrentInvoice.Details.Agent != null && CurrentInvoice.Details.Agent.ID != null && CurrentInvoice.Details.IsSignedByAgent && this.Products.length > 0;">
                <img [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.Agent?.Signature" class="signatureImage" />
              </div>
            </div>
            <div class="PopUpBodyOneThirddContainer">
              <div class="PopUpBodyRowContainer">
                <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                  <mat-label>{{ 'SignStampSubstitute' | translate }}</mat-label>
                  <textarea autocomplete="off" matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="5"
                            cdkAutosizeMaxRows="5"
                            [(ngModel)]="CurrentInvoice.Details.SignStampSubstitute" disabled="disabled"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>

            <div class="PopUpBodyRowContainer" style="margin-top: 30px;">
              <div class="PopUpBodyOneThirddContainer">

                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaReception">
                    <mat-label>{{ 'InvoiceCreatingAgent' | translate }}</mat-label>
                    <mat-select [(ngModel)]="CurrentInvoice.Details.Agent" name="Agent" [compareWith]="compareFn">
                      <mat-option *ngFor="let a of this.Agents" [value]="a">
                        {{a.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaReception">
                    <mat-label>{{ 'IDCARD' | translate }}/{{ 'PersonalIDNumber' | translate }}</mat-label>
                    <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentInvoice.Details.IDCard"></textarea>
                  </mat-form-field>
                </div>

                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaReception">
                    <mat-label>{{ 'WayBill' | translate }}</mat-label>
                    <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentInvoice.Details.WayBillID"></textarea>
                  </mat-form-field>
                </div>
              </div>
           
              <div class="PopUpBodyOneThirddContainer">
                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaReception">
                    <mat-label>{{ 'Receptions.Delegate' | translate }}</mat-label>
                    <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentInvoice.Details.Delegate"></textarea>
                  </mat-form-field>
                </div>
  
                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="txtAreaReception">
                    <mat-label>{{ 'Receptions.Auto' | translate }}</mat-label>
                    <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentInvoice.Details.Auto"></textarea>
                  </mat-form-field>
                </div>
              </div>

              <div class="PopUpBodyOneThirddContainer">
                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                    <mat-label>{{ 'Receptions.Mentions' | translate }}</mat-label>
                    <textarea autocomplete="off" matInput
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10"
                              [(ngModel)]="CurrentInvoice.Details.Observations"></textarea>
                  </mat-form-field>
                </div>
  
                <div class="PopUpBodyRowContainer">
                  <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                    <mat-label>{{ 'Receptions.InternalCommentary' | translate }}</mat-label>
                    <textarea autocomplete="off" matInput
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10"
                              [(ngModel)]="CurrentInvoice.Details.InternalCommentary"></textarea>
                  </mat-form-field>
                </div>

                <div class="PopUpBodyRowContainer" style="margin-top: 5px;">
                   <button mat-raised-button style="float:right;" (click)="TrackInvoice(this.CurrentInvoice);">
                    <i class="material-icons">near_me</i>
                    {{'Track' | translate}}
                   </button>

                    <button mat-raised-button style="float:right;margin-right: 10px;" (click)="GetShippingDetails(this.CurrentInvoice.Details.ID, this.CurrentInvoice.Client.ID);">
                      <i class="material-icons">local_shipping</i>
                      {{'ShippingDetails' | translate}}
                    </button>
                </div>

                <div class="PopUpBodyRowContainer" style="margin-top: 5px;">
                  <mat-slide-toggle [(ngModel)]="this.CurrentInvoice.Details.ForceDocumentClosing" style="margin-top: 14px;" matTooltip="{{'ForceDocumentClosingDesc' | translate}}" matTooltipClass='neutral-tool-tip'>{{'ForceDocumentClosing' | translate}}</mat-slide-toggle>
                </div>
              </div>
            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice.DocType.ID == 0 && CurrentInvoice?.Details?.EFacturaDetails?.Status.ID <= 0;">
              <button mat-raised-button color="primary" class="SaveReceptionButton" *ngIf="CurrentInvoice.ID == null;" (click)="AddInvoice();">
                 <span *ngIf="!IsStorno;">{{ 'SaveInvoice' | translate }}</span>
                 <span *ngIf="IsStorno;">{{ 'SaveStornoInvoice' | translate }}</span>
                 <i class="material-icons">save_alt</i>
              </button>
  
              <button mat-raised-button color="primary" class="SaveReceptionButton" *ngIf="CurrentInvoice.ID != null;" (click)="UpdateInvoice();">
                <span *ngIf="!IsStorno;">{{ 'UpdateInvoice' | translate }}</span>
                <span *ngIf="IsStorno;">{{ 'UpdateStornoInvoice' | translate }}</span>
                <i class="material-icons">save_alt</i>
             </button>
            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice.DocType.ID == 1 && CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID <= 0;">
              <button mat-raised-button color="primary" class="SaveReceptionButton" *ngIf="CurrentInvoice.ID == null;" (click)="AddInvoice();">
                 <span>{{ 'SaveProformaInvoice' | translate }}</span>
                 <i class="material-icons">save_alt</i>
              </button>
  
              <button mat-raised-button color="primary" class="SaveReceptionButton" *ngIf="CurrentInvoice.ID != null;" (click)="UpdateInvoice();">
                <span>{{ 'UpdateProformaInvoice' | translate }}</span>
                <i class="material-icons">save_alt</i>
             </button>

             <div class="PopUpBodyRowContainer" style="margin-top: 20px;">
              <button mat-raised-button color="primary" class="SaveReceptionButton" style="background: #32aa3a;" *ngIf="CurrentInvoice.ID != null;" (click)="ConvertProformaToInvoiceQuestion(CurrentInvoice);">
                <span>{{ 'ConvertToInvoice' | translate }}</span>
                <i class="material-icons">save_alt</i>
              </button>
             </div>
          
            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice.DocType.ID == 2 && CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID <= 0;">
              <button mat-raised-button color="primary" class="SaveReceptionButton" *ngIf="CurrentInvoice.ID == null;" (click)="AddInvoice();">
                 <span>{{ 'SaveAdvanceInvoice' | translate }}</span>
                 <i class="material-icons">save_alt</i>
              </button>
  
              <button mat-raised-button color="primary" class="SaveReceptionButton" *ngIf="CurrentInvoice.ID != null;" (click)="UpdateInvoice();">
                <span>{{ 'UpdateAdvanceInvoice' | translate }}</span>
                <i class="material-icons">save_alt</i>
             </button>
            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID > 0;">
              <button mat-raised-button color="primary" class="SaveReceptionButton" disabled="true">
                 <span>{{ 'LockedByEFactura' | translate }}</span>
                 <i class="material-icons">lock_outline</i>
              </button>
            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID > 0;" style="margin-top: 20px;">
              <button mat-raised-button color="primary" class="SaveReceptionButton" (click)="UpdateInvoiceDetails();">
                <span>{{ 'InvoiceOnlyDetailsUpdateBecauseEFacturaLock' | translate }}</span>
                <i class="material-icons">sync_lock</i>
             </button>
            </div>
          </div>
    </div>
</div>

